import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/home.png'
import _imports_1 from '@/assets/addr.png'
import _imports_2 from '../../assets/tel.png'


const _withScopeId = n => (_pushScopeId("data-v-0354080b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cls-flex",
  style: {"background":"white"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"1.5rem","height":"auto"}
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { style: {"flex":"1"} }
const _hoisted_5 = { style: {"padding":"0.7rem"} }
const _hoisted_6 = {
  class: "cls-flex",
  style: {"padding-bottom":"1rem"}
}
const _hoisted_7 = { class: "shop-info" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "desc one-hide" }
const _hoisted_11 = { class: "addr-con" }
const _hoisted_12 = {
  class: "desc cls-flex",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_13 = { style: {"flex":"1"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"auto","height":"0.9rem"}
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.2rem"} }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.5rem"} }, null, -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"auto","height":"0.9rem"}
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.2rem"} }, null, -1))
const _hoisted_21 = { class: "cls-flex" }
const _hoisted_22 = { class: "price-con" }
const _hoisted_23 = { style: {"font-weight":"bold"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price-tag" }, "价值", -1))
const _hoisted_25 = { class: "shop-info desc" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务名称：", -1))
const _hoisted_27 = { style: {"color":"#333"} }
const _hoisted_28 = { style: {"padding-top":"0.2rem"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务内容：", -1))
const _hoisted_30 = { style: {"color":"#333"} }
const _hoisted_31 = { style: {"padding-top":"0.2rem"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "使用说明：", -1))
const _hoisted_33 = { style: {"color":"#333"} }
const _hoisted_34 = {
  key: 0,
  style: {"padding-top":"0.2rem"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "剩余次数：", -1))
const _hoisted_36 = { style: {"color":"#333"} }
const _hoisted_37 = {
  key: 1,
  style: {"padding-top":"0.2rem"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "包含次数：", -1))
const _hoisted_39 = { style: {"color":"#333"} }
const _hoisted_40 = {
  key: 2,
  class: "border-btm"
}
const _hoisted_41 = { class: "cart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "home-btn cls-center",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.to_home && _ctx.to_home(...args)))
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_search, {
          modelValue: _ctx.reqData.text,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reqData.text) = $event)),
          shape: "round",
          placeholder: "商家名称或者服务名称等",
          onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab_change(_ctx.config.tabIdx)))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_van_tabs, {
      active: _ctx.tabIdx,
      "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tabIdx) = $event)),
      onChange: _ctx.tab_change,
      color: "#D8C14F"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabArr, (tab) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: tab.sortName,
            key: tab.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_van_list, {
                  loading: _ctx.loading,
                  "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
                  finished: _ctx.finished,
                  "finished-text": _ctx.finishedTxt,
                  error: _ctx.error,
                  "onUpdate:error": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.error) = $event)),
                  "error-text": "加载失败，点击重试",
                  onLoad: _ctx.req_items
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "white-radius",
                        key: item.id
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_van_image, {
                            src: item.thumb,
                            width: "5rem",
                            height: "5rem",
                            radius: "5"
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(item.storeName), 1),
                            _createElementVNode("div", _hoisted_9, "营业时间：" + _toDisplayString(item.businessHours), 1),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", null, "距离" + _toDisplayString(item.distance), 1),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(item.address) + _toDisplayString(item.addressDetail), 1)
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, "到店" + _toDisplayString(item.toStoreCustomerNum) + "人", 1),
                              _createElementVNode("div", {
                                class: "black cls-flex",
                                onClick: ($event: any) => (_ctx.map_click(item))
                              }, [
                                _hoisted_15,
                                _hoisted_16,
                                _createTextVNode(" 导航 ")
                              ], 8, _hoisted_14),
                              _hoisted_17,
                              _createElementVNode("div", {
                                class: "black cls-flex",
                                onClick: ($event: any) => (_ctx.tel_click(item.leadPhone))
                              }, [
                                _hoisted_19,
                                _hoisted_20,
                                _createTextVNode(" 拨号 ")
                              ], 8, _hoisted_18)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serveJson, (serve, i) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, "￥" + _toDisplayString(serve.servePrice), 1),
                              _hoisted_24
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", null, [
                                _hoisted_26,
                                _createElementVNode("span", _hoisted_27, _toDisplayString(serve.serveName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("span", _hoisted_30, _toDisplayString(serve.serveContent), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("span", _hoisted_33, _toDisplayString(serve.useExplain), 1)
                              ]),
                              (_ctx.user.isCxcard)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createElementVNode("span", _hoisted_36, _toDisplayString(serve.surplusNum), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(serve.serveNum), 1)
                                  ])),
                              (i + 1 < item.serveJson.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 256))
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "finished-text", "error", "onLoad"])
              ])
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active", "onChange"]),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_van_icon, {
        name: _ctx.cardImg,
        size: "3.5rem",
        onClick: _ctx.card_click
      }, null, 8, ["name", "onClick"])
    ])
  ], 64))
}